import { render, staticRenderFns } from "./QuestionFillBlanks.vue?vue&type=template&id=18711a34&scoped=true&"
import script from "./QuestionFillBlanks.vue?vue&type=script&lang=js&"
export * from "./QuestionFillBlanks.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFillBlanks.vue?vue&type=style&index=0&id=18711a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18711a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
